/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { getComponentZoneLayout } from "cms/components/components/component";
import { DNVLoginComponentDisplay } from "cms/components/external/dnv/login-button/display";
import { DNVLoginComponentEditor } from "cms/components/external/dnv/login-button/edit";

const DNVLoginComponent = (props) => {
    
    const { ...everything } = props;
    const zoneProps = {
        ...everything,
        displayComponent: <DNVLoginComponentDisplay />,
        editComponent: <DNVLoginComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
};

DNVLoginComponent.displayName = "DNVLoginComponent";
export { DNVLoginComponent };
